import { client } from 'app/http';
import { TRole } from 'app/types/entities/TRole';

export const getAvailableWorkspaceTeams = async (orgSlug: string, slug: string): Promise<{ result: TRole[] }> => {
  const { data } = await client.get(`workspaces/${orgSlug}/${slug}/teams/available`);
  return data;
};
